export const VITE_API_URL = import.meta.env.VITE_API_URL;
export const VITE_SIP_WS = import.meta.env.VITE_SIP_WS;
export const VITE_LIVEKIT_HOST = import.meta.env.VITE_LIVEKIT_HOST;
export const VITE_SKIP_INBOUND_SIP_CONFIG = import.meta.env.VITE_SKIP_INBOUND_SIP_CONFIG === 'true';
export const VITE_DISABLE_BROWSER_NOISE_SUPPRESSION =
  import.meta.env.VITE_DISABLE_BROWSER_NOISE_SUPPRESSION === 'true';
